/* -------------------------------------------------------------------------- *
 * Increment *
 * -------------------------------------------------------------------------- *
 * Increments a number from zero up to it's value.
 *
 * -------------------------- *
 * Element Attributes *
 * -------------------------- *
 * class="js-count"
 * data-number="100"
 */

const settings = {
    selector: '.js-count',
    observer: {
        rootMargin: '0px',
        threshold: 0.5,
    },
};

function countDecimals(num) {
    if (Math.floor(num.valueOf()) === num.valueOf()) {
        return 0;
    }
    return num.toString().split('.')[1].length || 0;
}

function incrementNumber(el) {
    // Target number
    const number = Number(el.getAttribute('data-number'));
    const decimals = countDecimals(number);

    // 20 increments x 50ms = 1s
    const increment = number / 20;

    let counter = 0;

    // Lock the width of the element
    el.style.minWidth = `${el.offsetWidth}px`;

    // Increase the number until the target number is reached
    const interval = setInterval(() => {
        if (counter < number) {
            counter += increment;
            el.innerHTML = counter.toFixed(decimals);
        } else {
            el.innerHTML = Number(number).toLocaleString();
            clearInterval(interval);
        }
    }, 50);
}

const observer = new IntersectionObserver((entries) => {
    // Check if number is visible
    entries.forEach((entry) => {
        if (entry.isIntersecting === true) {
            // Stop checking visibility and animate number
            observer.unobserve(entry.target);
            incrementNumber(entry.target);
        }
    });
}, settings.observer);

/* ------------- *
 * Module Export *
 * ------------- */

const Increment = {
    init(selector = settings.selector) {
        const numbers = document.querySelectorAll(selector);
        const number_arr = Array.from(numbers);

        // Set the visible number to zero and wait for number to become visible
        number_arr.forEach((el) => {
            el.innerHTML = 0;
            observer.observe(el);
        });
    },
};

export default Increment;
